/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { useCalendar } from "./useCalendar";
import { convertCalendarItem } from "../utils/convertCalendarItem";
import { fillCalendar } from "../utils/fillCalendar";
import { getGroups } from "../utils/getGroups";
import { useCalendarItems } from "./useCalendarItems";
import { ICalendarSelectorGroup } from "../types";
import { useCalendarValue } from "./useCalendarValue";

export function useCalendarGroups(): [ICalendarSelectorGroup[], (value: ICalendarSelectorGroup[]) => void] {
  const context = useCalendar();
  const [items] = useCalendarItems();
  const [value] = useCalendarValue();
  const [state, setState] = useState<ICalendarSelectorGroup[]>([]);

  const groups = useMemo(() => {
    const selectorItems = (items || []).map((item) => {
      const active = value ? (Array.isArray(value) ? value.map(String) : `${value}`).includes(item.id) : false;
      return convertCalendarItem(item, active);
    });
    if (context.fillBlanks) {
      const fullSelectorItems = fillCalendar(selectorItems, context.groupSize, context.fillBlanks);
      return getGroups(fullSelectorItems, context.groupSize, context.groupMask || undefined);
    }
    return getGroups(selectorItems, context.groupSize, context.groupMask || undefined);
  }, [context, items, value]);

  useEffect(() => {
    setState(groups);
  }, [JSON.stringify(groups)]);

  return [state, setState];
}
